// alterado - revisado

import {
    SvgIcon,
} from '@material-ui/core'

import { ReactComponent as grupoCoberturaSeguroVidaMorteSvg } from './grupoCoberturaSeguroVidaMorte.svg'

import { ReactComponent as grupoCoberturaSeguroVidaInvalidezAcidenteSvg } from './grupoCoberturaSeguroVidaInvalidezAcidente.svg'

import { ReactComponent as grupoCoberturaSeguroVidaInvalidezDoencaSvg } from './grupoCoberturaSeguroVidaInvalidezDoenca.svg'

import { ReactComponent as grupoCoberturaSeguroVidaDoencasGravesSvg } from './grupoCoberturaSeguroVidaDoencasGraves.svg'

import { ReactComponent as grupoCoberturaSeguroVidaIncapacidadeTemporariaSvg } from './grupoCoberturaSeguroVidaIncapacidadeTemporaria.svg'

import { ReactComponent as grupoCoberturaSeguroVidaFuneralSvg } from './grupoCoberturaSeguroVidaFuneral.svg'

import { ReactComponent as grupoCoberturaSeguroVidaAssistenciaSvg } from './grupoCoberturaSeguroVidaAssistencia.svg'



export const SvgIconGrupoCoberturaSeguroVidaMorte = ( props ) => {
    return (
        <SvgIcon
            component={grupoCoberturaSeguroVidaMorteSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconGrupoCoberturaSeguroVidaInvalidezAcidente = ( props ) => {
    return (
        <SvgIcon
            component={grupoCoberturaSeguroVidaInvalidezAcidenteSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconGrupoCoberturaSeguroVidaInvalidezDoenca = ( props ) => {
    return (
        <SvgIcon
            component={grupoCoberturaSeguroVidaInvalidezDoencaSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconGrupoCoberturaSeguroVidaDoencasGraves = ( props ) => {
    return (
        <SvgIcon
            component={grupoCoberturaSeguroVidaDoencasGravesSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconGrupoCoberturaSeguroVidaIncapacidadeTemporaria = ( props ) => {
    return (
        <SvgIcon
            component={grupoCoberturaSeguroVidaIncapacidadeTemporariaSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconGrupoCoberturaSeguroVidaFuneral = ( props ) => {
    return (
        <SvgIcon
            component={grupoCoberturaSeguroVidaFuneralSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconGrupoCoberturaSeguroVidaAssistencia = ( props ) => {
    return (
        <SvgIcon
            component={grupoCoberturaSeguroVidaAssistenciaSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}